import { connect } from 'react-redux';

import GroupListItem from './GroupListItem';

import {
  selectors as groupSelectors,
  operations as groupOperations,
} from '../../../../store/groups';
import { currentUser } from '../../../../../core/selectors/user';
import { isInstructor } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state, ownProps) => {
  const group = groupSelectors.group(state, ownProps.group) || {};
  const user = currentUser(state);
  const isCurrentUserInstructor = isInstructor(state, user.objectId);

  return {
    groupId: ownProps.group,
    name: group.name,
    avatar: group.avatar,
    numMembers:
      group.students && group.educators
        ? group.students.length + group.educators.length
        : 0,
    isInstructor: isCurrentUserInstructor,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onEditGroup: () => dispatch(groupOperations.openEditGroup(ownProps.group)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupListItem);
